import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import AdditionalOptions from '../components/Create/AdditionalOptions';

import {
    setNewBookingPrivateUse,
} from '../actions/newBooking';

function mapStateToProps(state) {
    const { person } = state.environment;
    const { privateUse } = state.newBooking;

    return {
        person,
        privateUse,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setNewBookingPrivateUse,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalOptions);



// WEBPACK FOOTER //
// ./scripts/containers/AdditionalOptionsContainer.jsx